var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataInsurance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 26.7697L30.1107 9.36334L49.8182 26.7697H44.6186V47.5452H14.755V26.7697H10Z",
    stroke: "#222222",
    strokeWidth: 2.18182
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0386 9.6029L49.4487 26.7231H49.4501L30.0393 9.60229L30.0386 9.6029ZM44.3288 26.7235H44.3279V47.1577H44.3288V26.7235ZM25.2031 41.198H34.4759L32.5321 32.0646C33.707 31.2157 34.4759 30.0237 34.4759 28.4528C34.4759 25.8661 32.4005 23.7435 29.8391 23.7435C27.2793 23.7435 25.2031 25.7878 25.2031 28.3745C25.2031 29.9445 25.972 31.2268 27.1477 32.0782L25.2031 41.198Z",
    fill: "#6484F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataInsurance);
export default __webpack_public_path__ + "static/media/data-insurance.04c3a3c803a7b69cf6e610aa8ffe3354.svg";
export { ForwardRef as ReactComponent };